<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label style="margin-left:0.625rem ;">小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-checkbox  @change="failDataCheck" style="font-size: 0.65rem;margin-left: 0.3rem;" >
							 只看异常数据
			</a-checkbox>
			<a-select  v-if="failOnly"  style="width:10rem; margin: 0 0.625rem;font-size: 0.6875rem;"  placeholder="选择异常类型"
						v-model="failStr"   @change="failChangeHandler" allowClear>
				<a-select-option v-for="(item,index) in failStrList" :key="item.index" :value="item.name">{{item.name}}
				</a-select-option>
			</a-select>
			<a-checkbox  @change="lihuCheck" style="font-size: 0.65rem;margin-left: 0.3rem;">
							 只看立户表
			</a-checkbox>
			
			<a-button type="primary"  size="small" style="margin: 0 0.625rem" :disabled ="list.length==0" @click="exportData" :loading="exportLoading">导出异常数据</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"   ref="mTable"
						  resizable highlight-hover-row :loading="loading"   size="mini" :cell-style="cellClassName">
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum" width="85"></vxe-table-column>
				<vxe-table-column title="立户" field="Lihu" width="85" :formatter="getLiHuStatus"></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
				<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
				<vxe-table-column title="表状态" field="MeterState" :formatter="getMeterState"></vxe-table-column>
				<vxe-table-column title="上次抄表读数" field="ActionResult" ></vxe-table-column>
				<vxe-table-column title="上次抄表时间" field="ActionTime"  :formatter="getTimeFormatter"></vxe-table-column>
				<vxe-table-column title="本次抄表读数" field="readdata"></vxe-table-column>
				<vxe-table-column title="本次抄表时间" field="readtime" :formatter="getTimeFormatter"></vxe-table-column>
				<vxe-table-column title="抄表结果分析" field="analyseResult" :title-help="{icon:'vxe-icon--question',message:'读数异常： 本次抄表读数小于0\n用水量异常： 本次读数小于上次读数\n用水量为0： 本次读数等于上次读数\n用水量超过阀值： 用水量超过40\n用水量远大于平均值： 用水量超过过去6个月平均用水量的1.5倍'}"></vxe-table-column>
				<vxe-table-column title="操作" field="MID">
					<template #default="{ row }">
						<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史读数曲线</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<a-drawer title="历史读数曲线" :visible="recentHistoryFlag"  width="60%" @close="recentHistoryClose()" :destroyOnClose='true'>
			<ShowMeterRecentHistory :theObj="theShowData"/>
		</a-drawer>
	</div>
</template>

<script>
	import ShowMeterRecentHistory from '/src/components/ShowMeterRecentHistory.vue'
	export default{
		components:{
			ShowMeterRecentHistory,
		},
		data(){
			return{
				theNeighbor:undefined,
				neighborList:[],
				loading:false,
				list:[],
				dataList:[],
				recentHistoryFlag:false,
				theShowData:null,
				exportLoading:false,
				failOnly:false,
				lihuOnly:false,
				failStr:undefined,
			}
		},
		methods:{
			failChangeHandler:function(){
				if(this.theNeighbor == undefined){
					return;
				}
				if(this.failStr!=undefined){
					let array = [];
					for(var i = 0;i<this.dataList.length;i++){
						let item = this.dataList[i];
						if(item.analyseFlag == '0' && item.analyseResult == this.failStr){
							array.push(item);
						}
					}
					this.list = array;
				}else{
					this.list= this.getFailData();
				}
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(column.property == 'analyseResult'){
					if(row.analyseFlag == '0'){
						style = {
								backgroundColor: '#ffee00',
								color: '#ff0000'
						}
					}
				}
				return style;
			},
			recentHistoryClose:function(){
				this.recentHistoryFlag = false;
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryData:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.list = result;
						this.showCheckData();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			reloadData:function(){
				if(this.theNeighbor){
					this.queryData();
				}else{
					this.$message.error('请选择小区');
				}
			},
			exportData:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_EXPORT_URL);
				var lihuOnly = this.lihuOnly?"1":"0";
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label,lihuOnly:lihuOnly};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '抄表结果分析-'+this.theNeighbor.label+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getLiHuStatus({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getLiHUList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			showHistoryData:function(record){
				this.theShowData = record;
				this.recentHistoryFlag = true;
			},
			failDataCheck:function(e){
				this.failOnly = e.target.checked;
				this.showCheckData();
			},
			lihuCheck:function(e){
				this.lihuOnly = e.target.checked;
				this.showCheckData();
			},
			showCheckData:function(){
				this.list = [];
				if(this.failOnly && this.lihuOnly){
					let l = this.getLihuData();
					let f = this.getFailData();
					let lSet = new Set(l);
					let fSet = new Set(f);
					this.list = Array.from(new Set(f.filter(v=>lSet.has(v))));
				}else if(this.failOnly && !this.lihuOnly){
					this.list= this.getFailData();
				}else if(!this.failOnly && this.lihuOnly){
					this.list= this.getLihuData();
				}else{
					this.list = this.dataList;
				}
			},
			getFailData:function(){
				let  temp = [];
				for(var  i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.analyseFlag == '0'){
						temp.push(item);
					}
				}
				return temp;
			},
			getLihuData:function(){
				let  temp = [];
				for(var  i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.Lihu == '1'){
						temp.push(item);
					}
				}
				return temp;
			},
		},
		created() {
			this.queryNeighbors();
		},
		computed:{
			failStrList:function(){
				var array = new Array();
				let obj1 = {
					name:"读数异常",
					index:1
				}
				array.push(obj1);
				let obj2 = {
					name:"用水量异常",
					index:2
				}
				array.push(obj2);
				let obj3 = {
					name:"用水量为0",
					index:3
				}
				array.push(obj3);
				let obj4 = {
					name:"用水量超过阀值",
					index:4
				}
				array.push(obj4);
				let obj5 = {
					name:"用水量远大于平均值",
					index:5
				}
				array.push(obj5);
				return array;
			},
		}
	}
</script>

<style>
</style>
